import { FormattedMessage } from 'react-intl';

import { PERMISSION } from 'src/features/auth/types';
import CloudUsers from 'src/features/cloudUsers/components/tables/CloudUsers';
import ValidationsTableAccountDashboard from 'src/features/validations/components/tables/ValidationsTableAccountDashboard';
import ValidationTypesTable from 'src/features/validationTypes/components/tables/ValidationTypesTable';
import { validationTypesMessages } from 'src/features/validationTypes/utils/messages';
import ValidatorAccountUsers from 'src/features/validatorAccounts/components/tables/ValidatorAccountUsers';
import { validatorAccountsMessages } from 'src/features/validatorAccounts/utils/messages';
import { ValidatorAccount } from 'src/features/validatorAccounts/utils/types';
import useHasPermissions from 'src/hooks/useHasPermissions';
import { Tabs, TabsContent, TabsList, TabsTrigger } from 'src/registry/ui/Tabs';

type ValidatorAccountDashboardTablesProps = {
    validatorAccount?: ValidatorAccount;
};

const ValidatorAccountDashboardTables = ({ validatorAccount }: ValidatorAccountDashboardTablesProps) => {
    const permissionAccessValidations = useHasPermissions([PERMISSION.MANAGE_VALIDATIONS]);
    const permissionAccessUsers = useHasPermissions([PERMISSION.ACCESS_USERS]);

    const defaultTabValue = (() => {
        if (permissionAccessValidations) return 'validation-types';
        if (permissionAccessValidations) return 'validations';
        if (permissionAccessUsers) return 'users';
        if (permissionAccessUsers) return 'cloud-users';
    })();

    const showTabsAndTables = permissionAccessValidations || permissionAccessUsers;

    if (!validatorAccount) return null;
    return (
        <div className="grid flex-3 grid-cols-1">
            {showTabsAndTables && (
                <Tabs defaultValue={defaultTabValue}>
                    <TabsList>
                        {permissionAccessValidations && (
                            <TabsTrigger value="validation-types">
                                <FormattedMessage {...validationTypesMessages.validationTypes} />
                            </TabsTrigger>
                        )}
                        {permissionAccessValidations && (
                            <TabsTrigger value="validations">
                                <FormattedMessage {...validationTypesMessages.validations} />
                            </TabsTrigger>
                        )}
                        {permissionAccessUsers && (
                            <>
                                <TabsTrigger value="users">
                                    <FormattedMessage {...validatorAccountsMessages.users} />
                                </TabsTrigger>
                                <TabsTrigger value="cloud-users">
                                    <FormattedMessage {...validatorAccountsMessages.cloudUsers} />
                                </TabsTrigger>
                            </>
                        )}
                    </TabsList>

                    {permissionAccessValidations && (
                        <TabsContent value="validation-types" className="w-full">
                            <ValidationTypesTable />
                        </TabsContent>
                    )}

                    {permissionAccessValidations && (
                        <TabsContent value="validations" className="w-full">
                            <ValidationsTableAccountDashboard />
                        </TabsContent>
                    )}
                    {permissionAccessUsers && (
                        <>
                            <TabsContent value="users" className="w-full">
                                <ValidatorAccountUsers />
                            </TabsContent>
                            <TabsContent value="cloud-users" className="w-full">
                                <CloudUsers />
                            </TabsContent>
                        </>
                    )}
                </Tabs>
            )}
        </div>
    );
};

export default ValidatorAccountDashboardTables;
